module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_5-8566b25fb923a5c9a17a0877c8b133ea.jpeg";